import {
  browserSupportsWebAuthn,
  startAuthentication,
  startRegistration,
  type PublicKeyCredentialCreationOptionsJSON,
  type PublicKeyCredentialRequestOptionsJSON,
} from "@simplewebauthn/browser";

/**
 * The web implementation of the passkey capabilities declared in shared-core's `PlatformCapabilities`. A shell spreads
 * this into its `platform/capabilities.ts`. This folder is the only place in the package that touches the browser.
 */
export const passkeyCapabilities = {
  passkeysAvailable: (): boolean => browserSupportsWebAuthn(),
  getPasskey: async (
    options: Record<string, unknown>,
  ): Promise<Record<string, unknown>> => {
    const credential = await startAuthentication({
      optionsJSON: options as unknown as PublicKeyCredentialRequestOptionsJSON,
    });
    return { ...credential };
  },
  createPasskey: async (
    options: Record<string, unknown>,
  ): Promise<Record<string, unknown>> => {
    const credential = await startRegistration({
      optionsJSON: options as unknown as PublicKeyCredentialCreationOptionsJSON,
    });
    return { ...credential };
  },
};
